exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PhoneInput{position:relative;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;padding-left:4px}.PhoneInput .country-code{color:grey;width:20px;text-indent:4px;letter-spacing:0}.PhoneInput input{background-color:#ffffff00;border:none;height:100%;width:100%}.PhoneInput input:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/PhoneInput/PhoneInput.scss
// module id = 1593
// module chunks = 0